// Full-document render of the California loadup (mattress pickup request)
// form: PageSkeleton wrapping LoadupRequestFormBody.
import React from "react";

import { templates } from "@reactivated";

import { LoadupRequestFormBody } from "../components/LoadupRequestFormBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoadupRequestFormDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LoadupRequestFormBody {...props} />
    </PageSkeleton>
);
